import { SystemRoutes } from "../../constants/routes";
import {
  clearLocalStorageExcept,
  clearSessionStorageExcept,
} from "features/../../../shared/helpers/System";

export const handleAmethystDeAuthenticate = (history: {
  push: (path: string) => void;
}) => {
  window.onbeforeunload = null;
  clearLocalStorageExcept();
  clearSessionStorageExcept();
  history.push(SystemRoutes.Logout);
};
